import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      userName: '',
      email: '',
      memberSince: '',
      pfp: '',
      is2FAEnabled: false,
      token: '',
      refresh_token: '',
      // theme:'light'
      // userName: 'Vasili Savitski',
      // email: 'vasili@gmail.com',
      // memberSince: '8/12/2020',
      // pfp: 'https://picsum.photos/id/22/200/300',
      // is2FAEnabled: false,
    }
  },

  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
    },

    setUser(userData: { userName: string; email: string; memberSince: string }) {
      this.userName = userData.userName
      this.email = userData.email
      this.memberSince = userData.memberSince
    },

    setToken(token: string) {
      this.token = token
    },
    setRefreshToken(token: string) {
      this.refresh_token = token
    },

    // setTheme(theme: string) {
    //   this.theme = theme
    // },

    clearUser() {
      this.userName = ''
      this.email = ''
      this.memberSince = ''
      this.token = ''
      this.refresh_token = ''
    },
  },
  getters: {
    isAuthenticated: (state) => state.token !== '',
    // isAuthenticated: (state) => true,
  },
})
